import React from "react";

export const PinIcon = ({ pinned }) =>
  pinned ? (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" className="pin-filled">
      <path d="M17 4v7l2 3v2h-6v5l-1 3-1-3v-5H5v-2l2-3V4c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2z" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" className="pin-outlined">
      <path d="M17 4v7l2 3v2h-6v5l-1 3-1-3v-5H5v-2l2-3V4c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2z" />
    </svg>
  );
